import React from 'react';
import { CheckCircle2, Calendar, Clock, ArrowRight, X } from 'lucide-react';
import { parseUtc } from '../lib/calendarDate';

// Brief Jul 7 2026 §1 — modal de confirmation après retour Stripe (paiement OK).
const PaymentSuccessModal = ({ info, onClose, onViewSession }) => {
  if (!info) return null;
  const start = info.start_time ? parseUtc(info.start_time) : null;
  const dateStr = start && !isNaN(start)
    ? start.toLocaleDateString('fr-CH', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
    : null;
  const timeStr = start && !isNaN(start)
    ? start.toLocaleTimeString('fr-CH', { hour: '2-digit', minute: '2-digit' })
    : null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4" data-testid="payment-success-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-sm rounded-2xl bg-white dark:bg-gray-800 shadow-2xl p-6 text-center">
        <button
          type="button"
          onClick={onClose}
          data-testid="payment-success-close"
          className="absolute top-3 right-3 p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-400"
        >
          <X className="h-5 w-5" />
        </button>
        <div className="mx-auto w-14 h-14 rounded-full bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center mb-3">
          <CheckCircle2 className="h-8 w-8 text-emerald-600 dark:text-emerald-400" />
        </div>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white">Paiement réussi !</h2>
        <p className="text-sm text-gray-600 dark:text-gray-300 mt-2" data-testid="payment-success-details">
          Tu es inscrit à <span className="font-semibold">{info.title || 'ta session'}</span>
          {dateStr && (
            <>
              <br />
              <Calendar className="inline h-3.5 w-3.5 mr-1 -mt-0.5" />
              le {dateStr}
              {timeStr && (
                <> <Clock className="inline h-3.5 w-3.5 ml-1 mr-1 -mt-0.5" /> à {timeStr}</>
              )}
            </>
          )}
        </p>
        <button
          type="button"
          onClick={onViewSession}
          data-testid="payment-success-view-session"
          className="mt-5 w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg bg-emerald-600 text-white text-sm font-semibold hover:bg-emerald-500"
        >
          Voir ma session <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccessModal;
